import EventsCalendar from "@/src/components/events/right-panel/event-calendar";
import EventsNextUp from "@/src/components/events/right-panel/event-next";
import { useResponsiveGap } from "@/src/hooks/use-responsive-gap";
import { useGetCalendarEventsQuery } from "@/src/services/api/events/events.hooks";
import { Slot, router } from "expo-router";
import { ScrollView, View } from "react-native";

export default function EventsLayout() {
  const gap = useResponsiveGap();
  const { data: calendarEvents } = useGetCalendarEventsQuery({
    filter: JSON.stringify({}),
    sort: JSON.stringify({ startTime: 1 }),
    pageNo: 1,
    pageSize: 100,
  });

  return (
    <View className={`flex-1 flex-row w-full bg-obsidian ${gap}`}>
      <View className="w-full md:w-[68%]">
        <Slot />
      </View>

      <ScrollView
        className="hidden md:flex md:w-[26%]"
        showsVerticalScrollIndicator={false}
        contentContainerStyle={{ flexGrow: 1 }}
      >
        <View className="gap-4">
          <EventsCalendar events={calendarEvents?.items ?? []} />
          <EventsNextUp
            events={calendarEvents?.items ?? []}
            onSeeAll={() => router.push("/events")}
            onEventPress={(event) => router.push(`/events/${event.ItemId}`)}
          />
        </View>
      </ScrollView>
    </View>
  );
}
